module.exports = __webpack_public_path__ + "static/media/bamboo-eco-ecology-svgrepo-com.1350c9b0.svg";